import React from 'react';
import PropTypes from 'prop-types';
import header from '../assets/icm-header.jpg';
import blank from '../assets/icm-blank.jpg';

const MAX_WIDTHS = {
  default: 600,
  compact: 550,
  print: 850,
};

const IcmHeaderImage = ({
  variant = 'default',
  showBlank = false,
  hidden = false,
  style = {},
}) => {
  if (hidden) {
    return <img src={blank} alt="" style={{ width: 0, height: 0 }} />;
  }

  return (
    <img
      src={showBlank ? blank : header}
      alt={showBlank ? '' : 'ICM - Instituto do Coração de Marília'}
      style={{
        width: '100%',
        maxWidth: MAX_WIDTHS[variant] || MAX_WIDTHS.default,
        height: 'auto',
        ...style,
      }}
    />
  );
};

IcmHeaderImage.propTypes = {
  variant: PropTypes.oneOf(['default', 'compact', 'print']),
  showBlank: PropTypes.bool,
  hidden: PropTypes.bool,
  style: PropTypes.object,
};

export default IcmHeaderImage;
